// Portfolio inclusion on NomOS (owner ruling 2026-10-20): a meter counts in portfolio totals exactly on the days of its
// active window, active_from .. active_to (inclusive); an absent bound is open-ended. There is no separate flag
// (the old counts_for_portfolio flag is retired). The totals themselves are the engine's roll-up (rollup roles
// counts_from / counts_to on those attributes); this is only for the screens that LIST counted meters.
import { scalar } from '../client';

const day = (v: unknown): string | null => {
  const s = scalar(v);
  return typeof s === 'string' && s.length >= 10 ? s.slice(0, 10) : null;
};

/** The meter's active window overlaps the period [start, end] (ISO days, inclusive). */
export function countsInPeriod(values: Record<string, unknown>, start: string, end: string): boolean {
  const from = day(values.active_from);
  const to = day(values.active_to);
  return (from === null || from <= end.slice(0, 10)) && (to === null || to >= start.slice(0, 10));
}

/** The attributes countsInPeriod reads. */
export const METER_WINDOW_FIELDS = ['active_from', 'active_to'] as const;
